import { Box, Stack, Typography } from "@mui/material";
import {
  getSensorStatusLabel,
  isSensorDisconnected,
  isSensorConnected,
} from "../../utils/sensorStatusUtils";
import { formattedDate } from "../../utils/dateUtils";
import { getMeasureDefinition } from "../../config/sensors.config";

const MapMarkerPopup = ({ marker }) => {
  const lastMeasure =
    (typeof marker?.state === "object" ? marker.state?.last_measure : null) ||
    marker?.last_measure;
  const statusColor = isSensorDisconnected(marker)
    ? "red"
    : isSensorConnected(marker)
      ? "green"
      : "grey";

  const measureData = Object.entries(lastMeasure || {})
    .filter(
      ([key, value]) =>
        key.toLowerCase() !== "timestamp" &&
        value !== null &&
        value !== undefined,
    )
    .map(([key, value]) => {
      const { label, unit } = getMeasureDefinition(key, marker);
      return { key, label, unit, value };
    });
  const timestamp = lastMeasure?.Timestamp || lastMeasure?.timestamp;

  return (
    <Box display="flex" flexDirection="column">
      <Stack direction="row" spacing={1}>
        <Typography fontWeight="bold" fontSize="14px">
          {marker.nickname}
        </Typography>
      </Stack>
      <Stack direction="row" spacing={1} alignItems="center" mb={2}>
        <Box
          borderRadius={20}
          bgcolor={statusColor}
          width="12px"
          height="12px"
        />
        <Typography fontSize="14px">{getSensorStatusLabel(marker)}</Typography>
      </Stack>
      {measureData.length > 0 ? (
        <>
          {measureData.map(({ key, label, unit, value }) => (
            <Stack key={key} direction="row" spacing={1} alignItems="center">
              <Typography fontWeight="bold" fontSize="14px">
                {label}:
              </Typography>
              <Typography fontSize="14px">
                {value} {unit}
              </Typography>
            </Stack>
          ))}
          {timestamp && (
            <Typography fontSize="12px" color="grey" mt={1}>
              {formattedDate(timestamp, true)}
            </Typography>
          )}
        </>
      ) : (
        <Typography fontSize="14px">Nessuna misurazione disponibile</Typography>
      )}
    </Box>
  );
};

export default MapMarkerPopup;
